import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SwitchToSameDeviceButtonProps {
  onSwitch: () => void;
  /** True while a new authorization is being requested: disables the button and shows `switchingLabel`. */
  isSwitching: boolean;
  label: string;
  switchingLabel: string;
}

/** Secondary action that restarts a bank authorization on the device the user is already using. */
export function SwitchToSameDeviceButton({
  onSwitch,
  isSwitching,
  label,
  switchingLabel,
}: SwitchToSameDeviceButtonProps) {
  return (
    <Button onClick={onSwitch} disabled={isSwitching} variant="outline" className="w-full" size="sm">
      {isSwitching ? (
        <>
          <Loader2 className="mr-2 h-3 w-3 animate-spin" />
          {switchingLabel}
        </>
      ) : (
        label
      )}
    </Button>
  );
}
